import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "you-tube-video" }
const _hoisted_2 = { class: "you-tube-video__icon" }
const _hoisted_3 = ["src"]

import { computed } from 'vue'

// Types
import type { Props } from './index'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPreview',
  props: {
    link: {}
  },
  setup(__props: any) {

const props = __props

// Computed
const id = computed<string | null>(() => youtubeParser(props.link))
const picture = computed<string | null>(() => (id) ? `//img.youtube.com/vi/${id.value}/0.jpg` : null)

// Methods
function youtubeParser(url: string): string | null {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  return (match && match[7].length == 11) ? match[7] : null
}

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_draw_svg, { name: "play-button" })
    ]),
    _createElementVNode("img", { src: picture.value }, null, 8, _hoisted_3)
  ]))
}
}

})